import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteMyCreationCharacter } from '~/api';
import { GetListForCreationResponse } from '~/types';
import useToast from '~/store/useToast';
import characterKey from './characterKey';

const useDeleteAvatarMutation = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteMyCreationCharacter,
    onError: (error) => {
      console.error(error);
      showToast('error', 'delete failed');
    },
    onSuccess: ({ status }, request) => {
      const prev = queryClient.getQueryData<GetListForCreationResponse>(
        characterKey.getListForCreation(),
      );
      if (prev && prev.data) {
        queryClient.setQueryData(characterKey.getListForCreation(), {
          ...prev,
          data: prev.data.filter((e) => e.avatar_id !== request.avatar_id),
        });
      }
      return;
    },
  });
};

export default useDeleteAvatarMutation;
